import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 14a.999.999 0 01-.707-.294L8 10.413l-3.293 3.293a.998.998 0 01-1.09.217.997.997 0 01-.617-.924v-9c0-1.102.897-2 2-2h6c1.103 0 2 .898 2 2v9a.997.997 0 01-1 1z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.999 21c-.39 0-.771-.154-1.06-.44L12 15.62l-4.939 4.94a1.497 1.497 0 01-1.635.325 1.495 1.495 0 01-.926-1.387V6c0-1.654 1.346-3 3-3h9c1.654 0 3 1.346 3 3v13.498A1.505 1.505 0 0117.999 21z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M35.998 41.999c-.78 0-1.542-.306-2.12-.88L24 31.239l-9.878 9.88a2.995 2.995 0 01-3.27.65A2.99 2.99 0 019 38.997V11.999c0-3.308 2.692-6 6-6h18c3.308 0 6 2.692 6 6v26.998a2.99 2.99 0 01-1.852 2.772 3.01 3.01 0 01-1.15.23z",
    clipRule: "evenodd"
  }))
};
export var BookmarkFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});